import { createPortal } from "react-dom";
import "./mediaUpload.css";

const STEPS = ["Upload", "Compressione", "Pubblicazione"];

export const MediaUploadOverlay = ({ progress = 0, phase = "Caricamento", step = 0, note }) => {
  const pct = Math.max(0, Math.min(100, Math.round(progress)));
  const R = 52;
  const C = 2 * Math.PI * R;

  return createPortal(
    <div className="mu-root" data-testid="media-upload-overlay">
      <div className="mu-grid" />
      <div className="mu-card">
        <div className="mu-ring">
          <svg width="116" height="116" viewBox="0 0 116 116">
            <circle cx="58" cy="58" r={R} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="7" />
            <circle
              cx="58" cy="58" r={R} fill="none" stroke="url(#muGrad)" strokeWidth="7"
              strokeLinecap="round" strokeDasharray={C}
              strokeDashoffset={C - (C * pct) / 100}
              style={{ transition: "stroke-dashoffset 0.5s cubic-bezier(0.2,0.8,0.2,1)" }}
            />
            <defs>
              <linearGradient id="muGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#FFC24D" />
                <stop offset="55%" stopColor="#FF6A3D" />
                <stop offset="100%" stopColor="#FF4D9A" />
              </linearGradient>
            </defs>
          </svg>
          <span className="mu-ring-val" data-testid="media-upload-percent">{pct}%</span>
        </div>

        <p className="mu-phase" data-testid="media-upload-phase">{phase}</p>
        {note && <p className="mu-sub">{note}</p>}

        <div className="mu-bar"><span style={{ width: `${pct}%` }} /></div>

        <div className="mu-steps">
          {STEPS.map((s, i) => (
            <span key={s} className="mu-step" data-on={i <= step}>{s}</span>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MediaUploadOverlay;
